import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { ApiGet, ApiPost } from '../../Api/api'
import { RootState } from '../rootReducer'
import {
  ActionTypes,
  DispatchType,
  getUser,
  GET_USER_ERROR,
  GET_USER_STARTED,
  GET_USER_SUCCESS,
  POST_USER_LOGOUT,
} from './types'
import { Routes } from '../../Components/Layout/RouteConfig'
import { ILogin } from '../../../type'
import axios from 'axios'

const setAuthToken = (token: string) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${
    token || Math.random().toFixed(21).substring(2)
  }`
}

export const userGet = (): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch
) => {
  dispatch(userStarted())
  try {
    const response = await ApiGet(`/users/`)
    dispatch(userSuccess(response.data))
  } catch (error) {
    console.error('There was an error!', error)
    dispatch(userError())
  }
}

export const userLogin = (credentials: ILogin, setError: Function, history: any) => async (
  dispatch: Function
) => {
  const response = await ApiPost('/users/login', credentials)

  if (response.status) {
    setError({ status: false, message: '' })
    const { token } = response.data

    localStorage.setItem('token', token)
    setAuthToken(token)

    if (credentials.remember) {
      localStorage.setItem('user', JSON.stringify(credentials))
    } else {
      localStorage.removeItem('user')
    }
    dispatch(userGet())
    history.push(`${Routes.projectsPage}`)
  } else {
    setError({ status: true, message: response.data.message })
  }
}

export function userError(): any {
  const action: ActionTypes = {
    type: GET_USER_ERROR,
  }
  return (dispatch: DispatchType) => dispatch(action)
}
export function userStarted(): any {
  const action: ActionTypes = {
    type: GET_USER_STARTED,
  }
  return (dispatch: DispatchType) => dispatch(action)
}

export function userSuccess(data: getUser): any {
  const action: ActionTypes = {
    type: GET_USER_SUCCESS,
    payload: data,
  }
  return (dispatch: DispatchType) => dispatch(action)
}

export const userPostSignOut = (): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch
) => {
  // dispatch(userStarted())
  return await ApiPost('/users/logout', {})
    .then((response) => {
      if (response.status) {
        localStorage.removeItem('token')
        dispatch(userSignOut())
      }
    })
    .catch((error) => {
      console.error('There was an error!', error)
      // dispatch(userError())
    })
}

export function userSignOut() {
  const action: ActionTypes = {
    type: POST_USER_LOGOUT,
  }
  return (dispatch: DispatchType) => dispatch(action)
}
